export function billingPeriod(start?: string | null, end?: string | null): string {
  if (!start || !end) return "기간 확인 필요";
  const last = new Date(`${end}T00:00:00Z`);
  last.setUTCDate(last.getUTCDate() - 1);
  return `${start} ~ ${last.toISOString().slice(0, 10)}`;
}
